import { render, staticRenderFns } from "./CampaignAutocomplete.vue?vue&type=template&id=f641b126&scoped=true&"
import script from "./CampaignAutocomplete.vue?vue&type=script&lang=js&"
export * from "./CampaignAutocomplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f641b126",
  null
  
)

export default component.exports